import { z } from 'zod';
export const PushSubscriptionDtoSchema = z.object({
    endpoint: z.string().url(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
    userAgent: z.string().optional(),
});
export const RegisterPushSubscriptionResponseSchema = z.object({
    id: z.string().uuid(),
    endpoint: z.string().url(),
    userId: z.string().uuid(),
    organizationId: z.string().uuid(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=push-schemas.js.map